import { Dialog, DialogContent, DialogTitle, Grow, IconButton, List, ListItem, Typography } from '@material-ui/core';
import { createStyles, StyledComponentProps, Theme, withStyles } from '@material-ui/core/styles';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import CloseIcon from '@material-ui/icons/Close';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcIsolator } from '../../comps/OcIsolator';
import { transl } from '../../main/transl';
import { Momentino } from '../../services/Momentino';
import { DataviewStore } from '../../stores/DataviewStore';
import { getOmnistore } from '../../stores/Omnistore';

const detailStore = DataviewStore.create({
	id: 'OrderDetail',
	orgColumns: [
		'name',
		'itemNo',
		'amountToOrder :int 30',
	],
	filtering: [{columns: ['name', 'itemNo'], value: ''}],
	sorting: {column: 'name'},
});

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props: TransitionProps, ref) => <Grow {...props} ref={ref}/>);

const styles = (theme: Theme) => createStyles({
	dialog: {
	},
	dialogContent: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	paper: {
		width: '100%',
		height: '100%',
		flex: 1,
		display: 'flex',
		maxWidth: '80%',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

interface IOrderDetailTopProps {
	entity: any //TODO
	onClick: () => void
}

@observer class OrderDetailTop extends React.Component<IOrderDetailTopProps> {
	render() {
		const {entity, onClick} = this.props;
		const e = Object.assign({}, entity);

		const date = e.date ? Momentino.dateTo.date(e.date) : '';
		const time = e.time ? e.time : '';
		const datetime = time ? date + ' ' + time : date;
		e.deliveryDatetime = datetime;
		e.pickupDatetime = datetime;

		const hidden = Symbol('hidden');
		const isPickup = !!e.pickupLocation;
		e.deliveryDatetime = isPickup ? hidden : datetime;
		e.pickupDatetime = isPickup ? datetime : hidden;
		e.pickupLocation = isPickup ? e.pickupLocation : hidden;
		e.paymentMethod = transl('Order_PaymentMethod.' + e.paymentMethod);
		e.status = transl('Order_Status.' + e.status);

		const fields = [
			'orderingUserEmail',
			'deliveryDatetime',
			'pickupDatetime',
			'pickupLocation',
			'paymentMethod',
			'status',
			'id',
		];

		return <List dense onClick={onClick}>{
			fields.filter(f => e[f] !== hidden).map(f =>
				<ListItem key={f} style={{display: 'flex', flexDirection: 'row'}}>
					<Typography style={{display: 'flex', flex: 40}}>{transl(f)}</Typography>
					<Typography style={{display: 'flex', flex: 60}}>{e[f]}</Typography>
				</ListItem>)
		}</List>;
	}
}

interface IOrderDetailProps {
	state: any //TODO
	entity: any //TODO
}

@observer class _OrderDetail extends React.Component<IOrderDetailProps & StyledComponentProps> {
	_onClose = () => this.props.state.rowClick(0)

	render() {
		const classes = this.props.classes || {};
		const {state, entity} = this.props;
		if (!entity) return null;

		const orderItemStore = getOmnistore().multirepo.orderItemRepo(state.selectedEntityId);
		orderItemStore.fetch();
		console.log('render', orderItemStore.id, orderItemStore.etag, orderItemStore.length);

		const repo = {
			etag: orderItemStore.etag,
			allAsList: orderItemStore.allAsList,
		};

		return <Dialog
			open={true}
			onClose={this._onClose}
			TransitionComponent={Transition}
			className={classes.dialogContent}
			classes={{paper: classes.paper}}
		>
			<DialogTitle>
				{entity.branchName} ♦ {entity.supplierName}
				<IconButton aria-label="Close" className={classes.closeButton} onClick={this._onClose}>
					<CloseIcon/>
				</IconButton>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<OrderDetailTop entity={entity} onClick={this._onClose}/>
				<OcIsolator dbgName="OrderDetail"
					outerStyle={{display: 'flex', flexDirection: 'column', flex: 1}}
					innerStyle={{display: 'flex', flexDirection: 'row'}}>
					<OcDataview repo={repo} state={detailStore}/>
				</OcIsolator>
			</DialogContent>
		</Dialog>;
	}
}

export const OrderDetail = withStyles(styles)(_OrderDetail);
